<template>
  <div :class="['enroll-exam-subject-setting', 'is-border']"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="isAllLoad">
      <template v-if="noDataLabel && noDataLabel.length">
        <Hint type="empty">
          <div>{{ noDataLabel.join('、') }}</div>
        </Hint>
      </template>
      <template v-else>
        <div class="header">
          <div class="headerList1">
            <span class="title">笔试安排查看时间设置</span>
            <div class="header-detail">
              <el-date-picker v-if="update"
                v-model="dataRange.enrollBatch.data.dateSetting"
                size="mini"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format = "yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              <span v-else>
                <template v-if="dataRange.enrollBatch.data.dateSetting && dataRange.enrollBatch.data.dateSetting.length > 0">
                  {{ dataRange.enrollBatch.data.dateSetting[0] }} 至 {{ dataRange.enrollBatch.data.dateSetting[1] }}
                </template>
                <template v-else>
                  暂未设置笔试安排查看时间
                </template>
              </span>
            </div>
          </div>
          <div class="headerList2">
            <span class="title">笔试考试须知</span>
            <div class="header-detail">
              <AmEditor v-model="dataRange.enrollBatch.data.writeNotice" :editorHeight="120" v-if="update"></AmEditor>
              <template v-else>
                <template v-if="dataRange.enrollBatch.data.writeNotice">
                  <div class="amView" v-html="dataRange.enrollBatch.data.writeNotice"></div>
                </template>
                <template v-else>
                  <div class="amNull">暂未设置笔试考试须知</div>
                </template>
              </template>
            </div>
          </div>
        </div>
        <el-button class="quit" size="mini" @click="quitUpdate" v-if="update">取消</el-button>
        <el-button class="commit" type="primary" size="mini" @click="updateWriteExamQueryDate" :loading="committing" v-if="update">提交</el-button>
        <el-button class="commit" type="primary" size="mini" @click="updateData" v-else>编辑</el-button>
        <div class="main">
          <div class="main-cont">
            <slot v-bind="select"></slot>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>请求数据加载失败</div>
        <el-button type="text"
                   @click="loadData">重新加载
        </el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../../../elements/Hint'
import Wrapper from '../../../../../../../mixins/custom/wrapper'
import AmEditor from '../../../../../../elements/editor/AmEditor'

export default {
  name: 'EnrollExamSubjectSetting',
  mixins: [Wrapper],
  components: {
    Hint, AmEditor
  },
  props: {
    dataTypes: {
      type: Array,
      required: true,
      validator: val => !!val.length
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true
    },
    studentType: {
      type: String,
      default: 'MBA'
    }
  },
  data () {
    return {
      dataRange: {
        enrollBatch: {
          url: '/workspace/manager/enrolling/exam/subject/query/active/enroll/batch',
          key: 'enrollBatch',
          label: '暂无开启的招生计划',
          data: null,
          updateData: null
        }
      },
      loading: false,
      select: {},
      committing: false,
      update: false
    }
  },
  computed: {
    isAllLoad () {
      return this.dataTypes.every(dataType => !!this.dataRange[dataType].data)
    },
    selectData () {
      return this.dataTypes.map(dataType => {
        return {
          dataType,
          ...this.dataRange[dataType]
        }
      })
    },
    noDataLabel () {
      return this.selectData.filter(option => !option.data || !Object.keys(option.data).length)
        .map(option => option.label)
    }
  },
  activated () {
    this.loadData()
  },
  methods: {
    updateData () {
      this.dataRange.enrollBatch.updateData = this.dataRange.enrollBatch.data
      this.update = true
    },
    quitUpdate () {
      this.update = false
    },
    loadData () {
      let promises = this.dataTypes.map(dataType => {
        let option = this.dataRange[dataType]
        return this.$ajax({
          url: option.url,
          method: 'post',
          data: this.$qs.stringify({
            studentType: this.studentType
          })
        })
      })
      this.loading = true
      Promise.all(promises).then(result => {
        this.dataTypes.forEach((dataType, index) => {
          let option = this.dataRange[dataType]
          option.data = result[index].data[option.key] || []
        })
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    updateWriteExamQueryDate () {
      if (!this.dataRange.enrollBatch.updateData.dateSetting) {
        this.$message.warning('请先选择笔试安排查看时间')
        return false
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/enrolling/exam/subject/update/write/setting',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          enrollBatchId: this.dataRange.enrollBatch.updateData.id,
          dateSetting: this.dataRange.enrollBatch.updateData.dateSetting,
          writeNotice: this.dataRange.enrollBatch.updateData.writeNotice
        }), {arrayFormat: 'repeat'})
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.dataRange.enrollBatch.data = this.dataRange.enrollBatch.updateData
              this.update = false
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss">
.enroll-exam-subject-setting {
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  position: relative;

  &.is-border {
    & > .header {
      border-bottom: 1px solid #ebeef5;
    }
  }

  & > .header {
    height: 220px;
    padding: 10px 15px 0;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    .headerList1{
      width: 30%;
      float: left;
      .title{
        font-size: 15px;
        white-space: nowrap;
      }
      .header-detail{
        padding-top: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .headerList2{
      width: 70%;
      float: left;
      .title{
        font-size: 15px;
        white-space: nowrap;
      }
      .header-detail{
        padding-top: 10px;
        position: relative;
        height: 165px;
        width: 100%;
        .amView{
          padding: 10px 15px 0;
          height: 161px;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          overflow: auto
        }
        .amNull{
          height: 161px;
        }
      }
    }
    //overflow: hidden;
  }
  & >  .commit{
    position: absolute;
    top: 8px;
    right: 15px;
  }
  & >  .quit{
    position: absolute;
    top: 8px;
    right: 80px;
  }

  & > .main {
    flex: auto;
    position: relative;
    & > .main-cont {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
}
</style>
